// extracted by mini-css-extract-plugin
export default {"buttonNavbar":"tabs_buttonNavbar__tiX6s"};